<!--
	its frontend

	Main frame of application, single site

    @file         App.svelte
    @author       Robert Fischer, fischer@tForge.eu
    @date         05/2022
    @copyright    tForge
-->




<script>
	import { PAGE, dockerVersion } 		from './config';
	import { URL_API, readVersion} 	    from './minions';
	import { CloudOffIcon, MenuIcon } 	from 'svelte-feather-icons';

	import P_login				from './Page_login.svelte';
	import P_home				from './Page_home.svelte';
	import P_liPro				from './Page_liPro.svelte';
	import P_liPro_light		from './Page_liPro_light.svelte';
	import P_camTe				from './Page_camTe.svelte';
	import P_benMa				from './Page_benMa.svelte';

	import M_menu				from './Modal_menu.svelte';

	let showMenu = false;
	let versionStr = 'v0.0.0'


// ================================ Message Box ==============================


	let messageVisible = false;
	let messageText = "";


	const showMessage = (evt) => {
		if (evt.detail.text) {
			messageText = evt.detail.text;
			messageVisible = true;
		}
	};//showMessage()




// =================================== Login =================================

    import { st_login } from './stores';

    let login;
    st_login.subscribe(value => {
		login = value;
	});


// ================================ Connection ===============================


	import { checkConnectionInterval_ms } from './config';


	// Interval set in onMount()
	let checkConnectionInterval;

	let serverReachable = false;

	const checkConnection = async (timeout_ms = 3000) => {

		// only check when app in foregound, i.e. active use
		if(document.visibilityState === "visible") {


			let controller = new AbortController();
			const tmo = setTimeout(() => controller.abort(), timeout_ms);

			const reply = await fetch(URL_API('ping'),
				{signal: controller.signal})
				.catch((err) => {
					console.log('ping timeout')
				});


			serverReachable = false;

			if (reply  && reply.ok){
				const msg = await reply.text();
				if (msg.includes('Greetings')){
					serverReachable = true;
				}
			}

			clearTimeout(tmo);

			if (!serverReachable) {
				messageText = "Sorry, tForge server can't be reached.\nPlease check your internet connection.";
				messageVisible = true;
			}
		}
	};//checkConnection()

	document.addEventListener("ononline", checkConnection);
	document.addEventListener("onoffline", checkConnection);



// ============================ Page navigation ==============================

	let selectedPage = PAGE.home;

	const closePage = (evt) => {
		console.log('Page closed');
		if (evt.detail.page) {
			selectedPage = evt.detail.page;
		}
		showMenu = false;
	};//closePage()


	// Displaying in fullscreen requires user interaction, e.g. pressing a button
	const toggleFullScreen = ()=> {
		var doc = window.document;
        var docEl = doc.documentElement;

        var requestFullScreen =
		docEl.requestFullscreen ||
		docEl.mozRequestFullScreen ||
		docEl.webkitRequestFullScreen ||
		docEl.msRequestFullscreen;
        var cancelFullScreen =
		doc.exitFullscreen ||
		doc.mozCancelFullScreen ||
		doc.webkitExitFullscreen ||
		doc.msExitFullscreen;

        if (
			!doc.fullscreenElement &&
            !doc.mozFullScreenElement &&
            !doc.webkitFullscreenElement &&
            !doc.msFullscreenElement
			) {
				requestFullScreen.call(docEl)
					.catch(()=>console.log("That's ok"));
			} else {
				cancelFullScreen.call(doc)
					.catch(()=>console.log("That's ok"));
			};
	};//toggleFullScreen()



// ========================== Construction / Init ============================

	import { onMount, onDestroy } 	from 'svelte';


	onMount(async () => {

		checkConnection();
		checkConnectionInterval = setInterval(checkConnection, checkConnectionInterval_ms);


		if (dockerVersion) {
			st_login.set({user:"Mechatronic", pwd:"visionTest", level:50, key:""});
			login.user = "Mechatronic";
			selectedPage = PAGE.liProLight;
		}
		//4dbg
		// st_login.set({user:"Robert", pwd:"theFineArtOfUsableScience", level:1000, key:""});
		// login.user = "Robert";

		versionStr = await readVersion();

	});//onMount()

	onDestroy(async () => {
		clearInterval(checkConnectionInterval);
	});//onDestroy()


</script>



<!-- =============================  H T M L  ============================= -->



<main>

	{#if login.user && !login.user.includes('forbidden')}
		<div id="topBar">
			<img id="logo" src="/img/tForge_Logo_text_blue.png" alt="" on:click={toggleFullScreen}>


			<div id="topBarRight">
				<div id="indicators">
					{#if !serverReachable}
					<div class="icon" on:click={checkConnection}>
						<CloudOffIcon />
					</div>
					{/if}
				</div>
				{#if dockerVersion}
				<div class="versionStr">{versionStr}</div>
				{:else}				
				<div on:click={()=> showMenu=true}>
					<MenuIcon size="2.5x" />
				</div>
				{/if}
			</div>
		</div>


		<div id="desk">
			{#if dockerVersion || selectedPage == PAGE.liProLight}
				<P_liPro_light
					 on:message={showMessage}/> 
			{:else if selectedPage == PAGE.home}
				<P_home on:close={closePage}
					on:message={showMessage}/>
			{:else if selectedPage == PAGE.liPro}
				<P_liPro on:close={closePage}
					on:message={showMessage}/>
			{:else if selectedPage == PAGE.camTe}
				<P_camTe on:close={closePage}
					on:message={showMessage}/>
			{:else if selectedPage == PAGE.benMa}
				<P_benMa on:close={closePage}
					on:message={showMessage}/>
			{:else}
				<P_home on:close={closePage}
					on:message={showMessage}/>
			{/if}
		</div>


		{#if showMenu}
			<M_menu on:close={closePage}/>
		{/if}


	{:else}

		<P_login on:close={closePage} on:message={showMessage}/>

	{/if}







	<!-- Full screen info box / message to user  -->
	{#if messageVisible && messageText && (messageText.length > 1)}
		<div class="message" on:click={()=> messageVisible = false}>
			<div class="message-box">
				{messageText}
			</div>
		</div>
	{/if}

</main>



<!-- ============================  S T Y L E  ============================ -->



<style>
	main {
		text-align: center;
		margin: auto;
		width: 100%;
		height: 100vh;
	}


	#topBar{
		padding: 0.5em 2em 0.5em 0.5em;
		position: fixed;
		top: 0px;
		color: var(--tF-blue);
		width: 100vW;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
		z-index: 50;
		background-color: rgba(255,255,255,0.65);
		backdrop-filter: blur(3px);
		box-shadow: 0px 1px 7px 5px rgba(0,0,0,0.15);
	}
	#topBar #logo{
		width: 25%;
		max-width: 200px;
		object-fit: contain;
		float: left;
	}
	#topBarRight {
		display: flex;
		flex-direction: row;
	}
	#indicators {
		display: flex;
		flex-direction: row;
		font-size: 1em;
		margin-right: 1em;
	}
	#indicators .icon{
		margin-right: 1em;
	}
	.versionStr {
		font-size: 0.8em;
        color: #444;
	}

	#desk {
		height: 100%;
		width: 100%;
	}

	/* Fullscreen message overlay */
	.message {
		white-space: pre-wrap;
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: rgba(255, 255, 255, 0.8);
		backdrop-filter: blur(5px);
		z-index: 50;
	}
	.message-box {
		padding: 2.5em;
		max-width: 60%;
		border: solid 1px var(--tF-blue);
		border-radius: 6px 6px 6px 6px;
	}

</style>